import styles from '@/styles/forms.module.scss';
import { AVAILABLE_LANGUAGES } from '@/services/localization';

/** LanguageSelector — список кнопок выбора языка */
export default function LanguageSelector({ onSelect }) {
  return (
    <div className={styles.languageList}>
      {AVAILABLE_LANGUAGES.map(lang => (
        <button
          key={lang.code}
          className={styles.languageBtn}
          onClick={() => onSelect(lang.code)}
          type="button"
        >
          <span className={styles.languageFlag}>{lang.flag}</span>
          {lang.label}
        </button>
      ))}
    </div>
  );
}
